// TODO check desired behavior, copied from discovery-pages-mcom
// For less than 9 rows, we only add Site Monetization Brand Showcase when the product row is complete. This method ensures that.
function isCompleteProductRow(numProducts, isPhone, aNoOfProdsPerRow) {
  let gamAds = 0;
  const noOfProds = aNoOfProdsPerRow * 2;
  const indexNo = isPhone ? noOfProds : (noOfProds - 1);
  if (numProducts > indexNo) {
    gamAds = 2;
  } else {
    gamAds = 1;
  }
  /* istanbul ignore else */
  if ((numProducts - gamAds) % aNoOfProdsPerRow === 0) {
    return true;
  }
  return false;
}

// TODO check desired behavior, copied from discovery-pages-mcom
export default function addBrandShowcasePlaceholder(items, aNoOfProdsPerRow, isPhone) {
  const brandShowcasePlaceholderView = {
    brandShowcasePlaceholder: {},
    fullWidth: true,
    excludeRow: true,
  };

  const noOfProds = aNoOfProdsPerRow * 9;
  const indexNo = noOfProds + 2;
  const isCompletedRow = isCompleteProductRow(items.length, isPhone, aNoOfProdsPerRow);
  /* istanbul ignore else */
  if (items.length > noOfProds || isCompletedRow) {
    return [
      ...items.slice(0, indexNo),
      brandShowcasePlaceholderView,
      ...items.slice(indexNo),
    ];
  }

  return items;
}
